<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" ref="form" :rules="rules">
        <el-row>
          <el-col :span="24" v-if="form.parentId !== '0'">
            <el-form-item :label="$t('base_template_tree_dialog.shang_ji_fen_zu')">
              <custom-select
                v-model="form.parentId"
                :disabled="parentIdOff"
                :placeholder="$t('Common.com_please_select')"
                :props="{
                  label: 'name',
                  value: 'value',
                  checkStrictly: true,
                }"
                :fullUrl="getReqFullUrl()"
                type="tree"
                :show-all-levels="false"
                :params="{}"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_template_tree_dialog.mu_ban_lei_xing')" prop="groupLevel">
              <custom-select v-model="form.groupLevel" code="bas_msg_template_group_level" :placeholder="$t('Common.com_please_select')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.groupLevel == '2'">
            <el-form-item :label="$t('base_template_tree_dialog.ye_wu_lei_xing')" prop="msgBizCode" class="is-required">
              <custom-select v-model="form.msgBizCode" code="bas_msg_biz_type" :placeholder="$t('Common.com_please_select')"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_template_tree_dialog.mu_ban_ming_cheng')" prop="groupName">
              <el-input v-model="form.groupName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_template_tree_dialog.mu_ban_bian_ma')" prop="groupCode">
              <el-input v-model="form.groupCode" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_template_tree_dialog.mu_ban_miao_shu')" prop="groupDesc">
              <el-input type="textarea" v-model="form.groupDesc" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// import Treeselect from '@riophae/vue-treeselect';
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  // components: { Treeselect },
  data() {
    return {
      templGroupId: '',
      form: {
        parentId: null,
        msgBizCode: '',
        templGroupId: '',
        groupLevel: '',
        groupName: '',
        groupCode: '',
        groupDesc: '',
      },
      // 分组类型禁用开关
      // groupLevelOff: false,
      parentIdOff: false,
    };
  },
  computed: {
    rules() {
      return {
        groupLevel: {
          required: true,
          message: this.$t('base_template_tree_dialog.mblxbx'),
        },
        msgBizCode: {
          required: true,
          message: this.$t('base_template_tree_dialog.ywlxbx'),
        },
        groupName: [
          {
            type: 'string',
            required: true,
            message: this.$t('base_template_tree_dialog.mbmcbt'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        groupCode: [
          {
            required: true,
            message: this.$t('base_template_tree_dialog.mbbmbt'),
          },
          {
            max: 50,
            message: this.$t('Common.com_rules_length_max', [50]),
          },
        ],
        groupDesc: {
          max: 200,
          message: this.$t('Common.com_rules_length_max', [200]),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    getReqFullUrl() {
      return `${apis.MsgTemplateGroupTree}/?groupLevel=1`;
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        // 清空重置值
        this.form.groupCode = '';
        this.form.groupDesc = '';
        this.form.groupName = '';
        if (this.model.data) {
          // 有父级
          this.parentIdOff = true;
          this.form.parentId = this.model.data.id || null;
        } else {
          // 无父级
          this.parentIdOff = false;
        }
        // this.parentIdOff= false;
        // 恢复分组类型
        // this.groupLevelOff = false;
      }
      if (this.model.type === 'edit') {
        // console.log('编辑', this.data);
        // this.form.parentId = this.data.parentId === '0' ? null : this.data.parentId;
        this.form.parentId = this.model.data.parentId || null;
        this.form.groupLevel = this.model.data.groupLevel;
        this.form.groupName = this.model.data.groupName;
        this.form.groupCode = this.model.data.groupCode;
        this.form.groupDesc = this.model.data.groupDesc;
        this.form.msgBizCode = this.model.data.msgBizCode;
        this.templGroupId = this.model.data.templGroupId;
        // 有父级 禁用选择
        this.parentIdOff = true;
        // 叶子选中禁用开关
        // this.groupLevelOff = this.data.groupLevelOff || false;
      }
    },

    // 确认保存分组
    saveGroup: function () {
      if (this.form.groupLevel !== '2') {
        this.rules.msgBizCode.required = false;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddGroup();
        }
        if (this.model.type === 'edit') {
          this.saveEditGroup();
        }
      });
    },
    getTreeProp(data, propName, defaultVal = '') {
      if (Array.isArray(data[propName])) {
        const len = Math.max(data[propName].length - 1, 0);
        return data[propName][len] || defaultVal;
      }
      return data[propName] || defaultVal;
    },
    getReqData() {
      return {
        ...this.form,
        parentId: this.getTreeProp(this.form, 'parentId'),
      };
    },
    // 保存新增分组
    saveAddGroup: function () {
      this.$postJSON(apis.MsgTemplateGroupAdd, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditGroup: function () {
      this.form.templGroupId = this.templGroupId;
      this.$postJSON(apis.MsgTemplateGroupUpdate, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success', this.getReqData());
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
